/* globals App $ */

var MobileDetect = require("mobile-detect");

class AppPopup {
  constructor($elem) {
    const detect = new MobileDetect(window.navigator.userAgent);
    $("#mob-menu").removeClass("top-[3.8rem]").addClass("top-[125px]");
    $elem.find(".close-popup").click((e) => {
      e.preventDefault();
      $elem.slideUp("fast");
      App.cookies.setCookie("app-closed", 1, 365);
      $("#mob-menu").removeClass("top-[125px]").addClass("top-[3.8rem]");
    });
    if (!App.cookies.getCookie("app-closed")) {
      if (detect.os() === "AndroidOS") {
        $elem.find("[data-android]").each((index, element) => {
          $(element).html($(element).data("android"));
        });
        $elem.find("[data-href-android]").each((index, element) => {
          $(element).attr("href", $(element).data("href-android"));
        });
        $elem.slideDown("fast");
      } else if (detect.os() === "iOS") {
        $elem.find("[data-ios]").each((index, element) => {
          $(element).html($(element).data("ios"));
        });
        $elem.find("[data-href-ios]").each((index, element) => {
          $(element).attr("href", $(element).data("href-ios"));
        });
        $elem.slideDown("fast");
      }
    }
  }
}

export { AppPopup };
